import { useCallback, useEffect, useRef, useState } from 'react';

import { RIGHT_PANEL_WIDTH_VAR } from './index';
import {
  getLocalStorage,
  setLocalStorage,
} from '../../../../utils/web-storage-wrapper';

const PERSISTED_WIDTH_KEY = 'article-right-panel-width';

type UseResizablePanelWidthOptions = {
  minWidth: number;
  maxWidth: number;
};

export const useResizablePanelWidth = ({
  minWidth,
  maxWidth,
}: UseResizablePanelWidthOptions) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isResizing, setIsResizing] = useState(false);

  useEffect(() => {
    const node = wrapperRef.current;
    if (!node) {
      return;
    }
    const stored = getLocalStorage(PERSISTED_WIDTH_KEY);
    if (!stored) {
      return;
    }
    const num = parseInt(stored, 10);
    if (Number.isNaN(num)) {
      return;
    }
    const clamped = Math.min(Math.max(num, minWidth), maxWidth);
    node.style.setProperty(RIGHT_PANEL_WIDTH_VAR, `${clamped}px`);
  }, [maxWidth, minWidth]);

  const handleResizeEnd = useCallback((width: number) => {
    setLocalStorage(PERSISTED_WIDTH_KEY, String(width));
  }, []);

  return {
    wrapperRef,
    isResizing,
    setIsResizing,
    handleResizeEnd,
  };
};
